import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const ComplexAccomodations = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.complexAccomodationsBody}
      />
    </ArticleBody>
  </div>
);

ComplexAccomodations.propTypes = {};

export default ComplexAccomodations;
